export const withHoldingDetailFields = {
  rows: [
    {
      col_1: [
        {
          id: "reason",
          readOnly: false,
          type: "causale"
        },
        {
          id: "cuReason",
          readOnly: true,
          type: "text",
          format: "currency"
        },
        {
          id: "tributeCode",
          type: "text",
          readOnly: true
        }
      ],
      col_2: []
    },
    {
      col_1: [
        {
          id: "taxableAmount",
          readOnly: true,
          type: "number",
          format: "currency"
        },
        {
          id: "totalNetAmount",
          readOnly: true,
          type: "number",
          format: "currency"
        },
        {
          id: "cashContribution",
          tooltip: true,
          readOnly: false,
          type: "number",
          format: "currency"
        },
        {
          id: "notIncomeAmount",
          readOnly: false,
          type: "number",
          format: "currency"
        },
        {
          id: "exemptIncome",
          readOnly: true,
          tooltip: false,
          type: "number",
          format: "currency",
          notZero: true // o visualizzo notWithholdingIncome o questo. Per ora discrimino != 0
        },
        {
          id: "notWithholdingIncome",
          readOnly: true,
          type: "number",
          format: "currency",
          notZero: true // o visualizzo notIncomeAmount o questo. Per ora discrimino != 0
        },        
        {
          id: "withholdingRate",
          type: "number",
          readOnly: true,
          format: "percentage"
        },      
        {
          id: "withHoldingDepositAmount",          
          notZero: true,
          type: "number",
          format: "currency",
          readOnly: true
        },
        {
          id: "withHoldingTaxAmount",          
          notZero: true,
          type: "number",
          format: "currency",
          readOnly: true
        }
      ],
      col_2: [
        null,
        null,
        null,
        {
          id: "taxableContribution",
          type: "toggle",
          readOnly: false
        }
      ]
    }
  ]
};

export const withHoldingDetailFieldsInps = {
  rows: [
    {
      col_1: [
        {
          id: "reason",
          readOnly: false,
          type: "causale"
        },
        {
          id: "cuReason",
          readOnly: true,
          type: "text",
          format: "currency"
        },
        {
          id: "tributeCode",
          type: "text",
          readOnly: true
        }
      ],
      col_2: []
    },
    {
      col_1: [
        {
          id: "socialInstituteTaxableAmount",
          type: "number",
          readOnly: true,
          format: "currency"
        },
        {
          id: "alreadySubjectedAmount",
          type: "number",
          readOnly: false,
          tooltip: true,
          format: "currency"
        },
        {
          id: "socialInstituteContributionRate",
          readOnly: true,
          type: "number",
          format: "percentage"
        },
        {
          id: "recipientContribution",
          type: "number",
          tooltip: true,
          readOnly: true
        },
        {
          id: "companyContribution",
          type: "number",
          readOnly: true
        }
      ],
      col_2: []
    },
    {
      col_1: [
        {
          id: "activityStartDate",
          type: "date",
          readOnly: false
        },
        {
          id: "emensOtherInsurance",
          type: "text",
          tooltip: true,
          readOnly: false
        },
        {
          id: "emensReportType",
          type: "text",
          tooltip: true,
          readOnly: true
        },
        {
          id: "ensarcoContribution",
          type: "number",
          conditionType: "RT04",
          readOnly: true,
          format: "currency"
        },
        {
          id: "enpamContribution",
          type: "number",
          conditionType: "RT05",
          readOnly: true,
          format: "currency"
        },
        {
          id: "othersContribution",
          type: "number",
          conditionType: "RT06",
          readOnly: true,
          format: "currency"
        }       
      ],
      col_2: [
        {
          id: "activityEndDate",
          type: "date",
          readOnly: false
        },
        {
          id: "emensActivityCode",
          type: "text",
          tooltip: true,
          readOnly: false
        }
      ]
    }
  ]
};
/* export const withHoldingDetailFields = [

];

export const withHoldingDetailFieldsInps = [

  {
    id: "divider",
    type: "hr"
  },

];
*/
